import { useState } from 'react';
import { UpgradeModal } from 'src/modules/ambient_solo/components/Payments/UpgradeModal';
import { ProIcon } from 'src/icons/Pro.icon';
import { useAuth } from '@frontegg/react';
import { analytics } from 'src/services';

export const UpgradeButton = ({
  text = 'Upgrade to access this feature',
  analyticsEvent = 'Clicked Upgrade Button',
}) => {
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const { user } = useAuth();

  const handleUpgrade = () => {
    analytics.track(analyticsEvent, { email: user?.email });
    setShowUpgradeModal(true);
  };

  return (
    <>
      <div className="p-4 rounded-lg">
        <p className="mb-3">{text}</p>
        <div className="flex justify-center">
          <button
            className="text-white bg-gradient-to-br from-pink-500 to-blue-700 bg-origin-border bg-clip-padding flex items-center p-2 rounded-xl hover:shadow-xl font-medium px-4 w-1/2 justify-center"
            type="button"
            onClick={handleUpgrade}
          >
            Upgrade
            <span className="ml-2">
              <ProIcon fill="#fff" forceFlashIcon={true} />
            </span>
          </button>
        </div>
      </div>
      <UpgradeModal
        isVisible={showUpgradeModal}
        setIsVisible={setShowUpgradeModal}
      />
    </>
  );
};
